function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState } from 'react';
import { connect } from 'react-redux';
import { modalActions } from '../../../reducers/modal.reducer';
import { settingsActions } from '../../../reducers/settings.reducer';
import ModalHeader from '../../modal/ModalHeader.react';
import Button from '../../common/Button.react';
import Input from '../../common/form/Input.react';
import Label from '../../common/form/Label.react';
import SelectApplication from '../../common/form/select/SelectApplication.react';
var ConstantsTemplateEdit = function ConstantsTemplateEdit(_ref) {
  var slug = _ref.slug,
    title = _ref.title,
    _ref$constant = _ref.constant,
    constant = _ref$constant === void 0 ? null : _ref$constant,
    constants = _ref.constants,
    _ref$disableSelectApp = _ref.disableSelectApp,
    disableSelectApp = _ref$disableSelectApp === void 0 ? false : _ref$disableSelectApp,
    hideModalAction = _ref.hideModalAction,
    setConstantsAction = _ref.setConstantsAction;
  var _useState = useState({
      clientApp: (constant === null || constant === void 0 ? void 0 : constant.clientApp) || '',
      description: (constant === null || constant === void 0 ? void 0 : constant.description) || '',
      key: (constant === null || constant === void 0 ? void 0 : constant.key) || '',
      name: (constant === null || constant === void 0 ? void 0 : constant.name) || '',
      value: (constant === null || constant === void 0 ? void 0 : constant.value) || ''
    }),
    _useState2 = _slicedToArray(_useState, 2),
    form = _useState2[0],
    setForm = _useState2[1];
  var clientApp = form.clientApp,
    key = form.key,
    name = form.name,
    value = form.value,
    description = form.description;
  var updateForm = function updateForm(key, value) {
    return setForm(_objectSpread(_objectSpread({}, form), {}, _defineProperty({}, key, value)));
  };
  var isValid = function isValid() {
    return name.length > 0 && value.length > 0;
  };
  var isDuplicate = function isDuplicate() {
    if (constant) return false;
    if (clientApp === '' && constants.filter(function (x) {
      return x.name.toLowerCase() === name.toLowerCase();
    })[0] || constants.filter(function (x) {
      return x.name.toLowerCase().trim() === name.toLowerCase().trim() && (x.clientApp === clientApp || x.clientApp === null);
    })[0]) return "Duplicate Name. Another constant with the same Name already exists in ".concat(title, ".");
    if (clientApp === '' && constants.filter(function (x) {
      return x.key.toLowerCase() === key.toLowerCase();
    })[0] || constants.filter(function (x) {
      return x.key.toLowerCase() === key.toLowerCase() && (x.clientApp === clientApp || x.clientApp === null);
    })[0]) return "Duplicate Key. Another constant with the same Key already exists in ".concat(title, ".");
    if (clientApp === '' && constants.filter(function (x) {
      return x.value.toLowerCase() === value.toLowerCase();
    })[0] || constants.filter(function (x) {
      return x.value.toLowerCase() === value.toLowerCase() && (x.clientApp === clientApp || x.clientApp === null);
    })[0]) return "Duplicate Value. Another constant with the same Value already exists in ".concat(title, ".");
    return false;
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "modal modal__320"
  }, /*#__PURE__*/React.createElement(ModalHeader, {
    title: "".concat(!constant ? 'Add' : 'Edit', " ").concat(title)
  }), /*#__PURE__*/React.createElement("div", {
    className: "modal__body"
  }, !constant && !disableSelectApp && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Label, {
    label: "Applications",
    info: "Select application touched by this constant."
  }), /*#__PURE__*/React.createElement(SelectApplication, {
    value: clientApp,
    onChange: function onChange(_ref2) {
      var sValue = _ref2.sValue;
      return updateForm('clientApp', sValue);
    }
  })), !constant && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Label, {
    label: "Name",
    required: true,
    info: "Set a name for your constant. This is the name displayed throughout your app.<br /><br />E.g. adding <span>Admin</span> to <span>User Roles</span> this could be named <span>Administrator</span>."
  }), /*#__PURE__*/React.createElement(Input, {
    value: name,
    onChange: function onChange(e) {
      return updateForm('name', e.target.value);
    }
  }), /*#__PURE__*/React.createElement(Label, {
    label: "Key",
    info: "Set a key for your constant. This refers to what your constant is named in the database.<br /><br />E.g. adding <span>Admin</span> to <span>User Roles</span> this could be named <span>admin</span>.<br /><br />This key is optional, but in general keep key and value identical."
  }), /*#__PURE__*/React.createElement(Input, {
    value: key,
    onChange: function onChange(e) {
      return updateForm('key', e.target.value.trim().toLowerCase().replace(/[^a-z-]/g, ''));
    }
  }), /*#__PURE__*/React.createElement(Label, {
    label: "Value",
    required: true,
    info: "Set a value for your constant. This is the value saved to the database.<br /><br />E.g. adding <span>Admin</span> to <span>User Roles</span> this value could be <span>admin</span>."
  }), /*#__PURE__*/React.createElement(Input, {
    value: value,
    onChange: function onChange(e) {
      return updateForm('value', e.target.value.trim().toLowerCase().replace(/[^a-z-]/g, ''));
    }
  })), /*#__PURE__*/React.createElement(Label, {
    label: "Description"
  }), /*#__PURE__*/React.createElement(Input, {
    value: description,
    onChange: function onChange(e) {
      return updateForm('description', e.target.value);
    }
  }), isDuplicate() && isDuplicate(), /*#__PURE__*/React.createElement(Button, {
    label: !constant ? 'Add' : 'Update',
    onClick: function onClick() {
      setConstantsAction({
        id: (constant === null || constant === void 0 ? void 0 : constant.id) || null,
        app: clientApp,
        description: description,
        key: key,
        name: name,
        value: value,
        slug: slug,
        title: title
      });
      hideModalAction();
    },
    width: "120px",
    disabled: !isValid() || isDuplicate()
  })));
};
var mstp = function mstp(s) {
  var _s$settings$constants;
  return {
    applicationConstants: ((_s$settings$constants = s.settings.constants) === null || _s$settings$constants === void 0 ? void 0 : _s$settings$constants.applications) || []
  };
};
var mdtp = {
  hideModalAction: modalActions.hide,
  setConstantsAction: settingsActions.setConstants
};
export default connect(mstp, mdtp)(ConstantsTemplateEdit);